import styled from 'styled-components'

export const Anchor = styled.a``

export const Wrapper = styled.div`
  margin-right: ${({ theme }) => theme.space.xxs};
  border-radius: 3px;
`
